export default function formatMoney(number, decimals = 0, decPoint = '.', thousandsSep = ',') {
  // number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  // let n = !isFinite(+number) ? 0 : +number
  // let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  // let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  // let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  // let s = ''
  // let toFixedFix = function (n, prec) {
  //   let k = Math.pow(10, prec)
  //   return '' + Math.ceil(n * k) / k
  // }
  // s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  // let re = /(-?\d+)(\d{3})/
  // while (re.test(s[0])) {
  //   s[0] = s[0].replace(re, '$1' + sep + '$2')
  // }
  // if ((s[1] || '').length < prec) {
  //   s[1] = s[1] || ''
  //   s[1] += new Array(prec - s[1].length + 1).join('0')
  // }
  // return s.join(dec)
  if (!number) {
    return "0.00";
  }
  number = ("" + number).trim();
  let array = number.split(decPoint);
  let zhengshu = array[0];
  zhengshu = zhengshu.split("").reverse().join("");
  zhengshu = zhengshu.replace(/(\d{3})/g, "$1 ").trim().replace(/ /g, thousandsSep);
  zhengshu = zhengshu.split("").reverse().join("");
  if (array.length == 1) {
    number = zhengshu + ".00";
  } else {
    number = zhengshu + parseFloat("0."+array[1]).toFixed(decimals).slice(1);
  }
  return number;
}



// WEBPACK FOOTER //
// ./src/modules/filter/formatMoney.js